import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'

const propTypes = {
  isCod: PropTypes.bool
}

const defaultProps = {
  isCod: false
}

/**
 * @param {bool} isCod
 */
const CustomerOrderCodBadge = ({ isCod }) => {

  const color = isCod ? 'success' : 'secondary'
  const label = isCod ? 'Yes' : 'No'

  return <StatusBadge color={ color } label={ label } />
}

CustomerOrderCodBadge.propTypes    = propTypes
CustomerOrderCodBadge.defaultProps = defaultProps

export default CustomerOrderCodBadge
